import React from "react";
import { useState, useRef, useEffect } from "react";
import "../../stylesheet/forms.css";
import { BsCheck } from "react-icons/bs";
import Topnav from "../others/Topnav";
import InventoryForm from "./InventoryForm";
import { InventorySuccess } from "../billings/InventorySuccess";
import InventorySummary from "./InventorySummary";
import ContextApi from "../../context/ContextApi";
import WStepper from "../utils/WizardStepper";

const NewInventory = () => {
  // const [inventoryCreated, setInventoryCreated] = useState(false);
  const [step, setStep] = useState(1);
  // const [billing, setBilling] = useState(null)
  // const [step, setStep] = useState(1);
  // const [searchParams] = useSearchParams();
  // const queryParams = searchParams.get('mode');
  const [formData, setFormData] = useState(null);

  const updateFormData = (newData) => {
    setFormData((prevData) => ({
      ...prevData,
      ...newData,
    }));
  };

  // const formContentRef = useRef(null);

  // const scrollToTop = () => {
  //   if (formContentRef.current) {
  //     formContentRef.current.scrollTo(0, 0);
  //   }
  // };

  // useEffect(() => {
  //   const storedStage = localStorage.getItem("inventory");
  //   if (storedStage) {
  //     setStep(parseInt(storedStage));
  //   }
  // }, []);

  const handleNext = () => {
    if (step <= 2) {
      // scrollToTop();
      setStep(step + 1);
      // localStorage.setItem("iinventory", step + 1);
    }

    console.log("Form data saved:", formData);
  };

  const handlePrevious = () => {
    if (step > 1) {
      // scrollToTop();
      setStep(step - 1);
      // localStorage.setItem("inventory", step - 1);
    }
  };

  return (
    <ContextApi.Provider
      value={{
        formData,
      }}
    >
      <div className="new">
        <Topnav />
        <div className="overflow-hidden">
          <div className="w-full flex items-center justify-center my-6">
            <WStepper
              currentTab={step}
              config={[
                {
                  name: "Inventory details",
                  status: "",
                },
                {
                  name: "Summary",
                  status: "Completed",
                },
              ]}
            />
          </div>
          <div className="w-full flex justify-center">
            <form
              id="new_inventry"
              className="overflow-auto md:w-8/12 w-full"
            >
              {step === 1 && (
                <div className="steps">
                  <h1>Inventory Details</h1>
                  <InventoryForm
                    formData={formData}
                    updateFormData={updateFormData}
                  />
                  <div className="form_btn">
                    <button type="button" onClick={handleNext}>
                      Continue
                    </button>
                  </div>
                </div>
              )}
              {step === 2 && (
                <div className="steps">
                  <div
                    className="             
                  "
                  >
                    <InventorySummary data={formData} />
                  </div>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </ContextApi.Provider>
  );
};

export default NewInventory;
